import { Fragment, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import Loader from "./../../component/Loader";
import {
  getContactInfo,
  formContact,
  getSocialMedia,
} from "../../store/contact/contactAction";
import { sucess, failed } from "../../component/toast/Toast";
import { useFormik } from "formik";
import { Link } from "react-router-dom";
import bg from "../../assets/pexels-max-fischer-5212320.jpg";

import img6 from "../../assets/main/6.jpg";
const Contact = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const lan = useSelector((state) => state.LanSlicer.language);

  return (
    <Fragment>
      <section
        class="flat-title-page back-ground-style"
        style={{ backgroundImage: `url(${img6})` }}
      >
        <div class="container-fluid">
          <div class="row">
            <div class="breadcrumbs text-center link-style-5 text-white">
              <h2 class="section-title-page">Our Services</h2>
              <ul class="breadcrumbs-inner list-center display-flex">
                <li>
                  <a
                    class="section-16px-regular font-weight-500"
                    href="index.html"
                  >
                    Home
                  </a>
                </li>
                <li>
                  <h4 class="section-16px-regular font-weight-500">
                    Our Services
                  </h4>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section class="flat-contact">
        <div class="container">
          <div class="row">
            <div class="col-md-5">
              <div class="about-content-left">
                <div class="section-title">
                  <h4 class="section-subtitle">Contact me</h4>
                  <h2 class="section-30px-montserrat margin-top-15 margin-bottom-20">
                    If need any info please
                    <br />
                    contact us!
                  </h2>
                </div>
                <div class="about-post">
                  <img src={bg} alt="images" />
                  <div class="mark-about-post"></div>
                </div>
              </div>
            </div>
            <div class="col-md-7">
              <div class="contact-content-right">
                <h3 class="section-20px-montserrat font-weight-500">
                  We’re glad to discuss your organisation’s situation. So please
                  contact us via the details below, or enter your request.
                </h3>
                <div class="form-contact">
                  <form
                    method="post"
                    id="contactform"
                    class="comment-form"
                    action="./contact/contact-process.php"
                    accept-charset="utf-8"
                    novalidate="novalidate"
                  >
                    <div class="text-wrap clearfix">
                      <fieldset class="name-wrap">
                        <input
                          type="text"
                          id="name"
                          class="tb-my-input"
                          name="name"
                          tabindex="1"
                          placeholder="Name"
                          value=""
                          size="32"
                          aria-required="true"
                          required=""
                        />
                      </fieldset>
                      <fieldset class="email-wrap">
                        <input
                          type="email"
                          id="email"
                          class="tb-my-input"
                          name="email"
                          tabindex="2"
                          placeholder="Email"
                          value=""
                          size="32"
                          aria-required="true"
                          required=""
                        />
                      </fieldset>
                      <fieldset class="subject-wrap">
                        <input
                          type="text"
                          id="subject"
                          class="tb-my-input"
                          name="subject"
                          placeholder="Subject Line"
                          value=""
                          aria-required="true"
                          required=""
                        />
                      </fieldset>
                    </div>
                    <fieldset class="message-wrap margin-bottom-10">
                      <textarea
                        id="comment-message"
                        name="message"
                        rows="10"
                        tabindex="4"
                        placeholder="Type Comments Here ..."
                        aria-required="true"
                      ></textarea>
                    </fieldset>
                    <button
                      name="submit"
                      type="submit"
                      role="button"
                      id="comment-reply"
                      class="arrow-btn btn-st style-5"
                    >
                      Submit Now
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="flat-contact-map">
        <div class="container-fluid">
          <div class="row">
            <div class="contact-map-box">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d27487.40795076452!2d31.04381039980901!3d30.551394900000005!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14f7d7d37840ebe7%3A0x96dfef0923e623e9!2zUGlvbmVlcnMgU29sdXRpb25z4oCP4oCP!5e0!3m2!1sar!2seg!4v1737381664121!5m2!1sar!2seg"
                class="map-contact"
                allowfullscreen=""
                title="contact-map"
                loading="lazy"
                referrerpolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
          </div>
        </div>
      </section>
    </Fragment>
  );
};

export default Contact;
